import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Banner = ({ content, onChangeMaskVisible, onChangeCurrentVideo }) => {
    useEffect(() => {
        const bannerPic = document.getElementById('bannerPic');
        const bannerTitle = document.getElementById('bannerTitle');
        const bannerLogo = document.getElementById('bannerLogo');
        const bannerBrand = document.getElementById('bannerBrand');
        const bannerBird = document.getElementById('bannerBird');
        const bannerPreview = document.getElementById('bannerPreview');
        // const bannerNext = document.getElementById('bannerNext');

        // eslint-disable-next-line no-undef
        TweenLite.to(bannerPic, 2, {
            scale: 1,
            delay: 1,
            // eslint-disable-next-line no-undef
            ease: Power2.easeInOut,
            onComplete: () => {
                // setBannerHeight('auto');
            },
        });
        // eslint-disable-next-line no-undef
        TweenLite.to(bannerTitle, 1, { opacity: 1, delay: 3, ease: Power2.easeInOut });
        // eslint-disable-next-line no-undef
        TweenLite.to(bannerBird, 1, { opacity: 1, delay: 3, ease: Power2.easeInOut });
        // eslint-disable-next-line no-undef
        TweenLite.to(bannerLogo, 1, { opacity: 1, delay: 3.5, ease: Power2.easeInOut });
        // eslint-disable-next-line no-undef
        TweenLite.to(bannerBrand, 1, { opacity: 1, delay: 3.5, ease: Power2.easeInOut });
        // eslint-disable-next-line no-undef
        TweenLite.to(bannerPreview, 1, { opacity: 1, delay: 4, ease: Power2.easeInOut });
    }, []);

    const openVideo = () => {
        onChangeCurrentVideo({
            url: content.videoUrl,
            guid: content.videoGuid,
            duration: content.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    // console.log(content, 'content')

    return (
        <div className={styles.banner} id="bannerBox">
            <div id="bannerPic" className={styles.bannerPic} />
            {/* <img id="bannerPicBase" className={styles.bannerEmpty} src="https://x0.ifengimg.com/ucms/2025_17/81BEFC09B94C7F8ECB055FAC5230B2E755B36851_size4417_w3840_h1782.jpg" />
            <img id="bannerPic" className={styles.bannerPic} src="https://x0.ifengimg.com/ucms/2025_17/81BEFC09B94C7F8ECB055FAC5230B2E755B36851_size4417_w3840_h1782.jpg" /> */}
            <img id="bannerLogo" className={styles.bannerLogo} src="https://x0.ifengimg.com/ucms/2025_17/306F51A57AB9A1FC63DBE0B51396454AA57EF60A_size16_w295_h107.png" />
            <img id="bannerBrand" className={styles.bannerBrand} src="https://x0.ifengimg.com/ucms/2025_17/43D2195265CF10A6C820C0630C820130F81BC46E_size6_w401_h34.png" />
            <img id="bannerBird" className={styles.bannerBird} src="https://x0.ifengimg.com/ucms/2025_17/85627AB8D4A1CB38D53904E08E7D3BE2C1A03BD2_size1_w156_h44.png" />
            <img id="bannerTitle" className={styles.bannerTitle} src="https://x0.ifengimg.com/ucms/2025_17/5776DC4151E044E6656695BC30128453BA8FB4E3_size227_w991_h1557.png" />
            <img id="bannerPreview" onClick={openVideo} className={styles.bannerPreview} src="https://x0.ifengimg.com/ucms/2025_17/E8D6CD5587F56F020F00A6367FBB6A4921757FCA_size1_w151_h62.png" />
        </div>
    );
};

Banner.propTypes = {
    content: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(Banner);
